// assets/flexible-popup.js
document.addEventListener('DOMContentLoaded', function() {
  const popupConfig = {
    message: window.popupMessage || '',
    pages: window.popupPages || ['/'], // Varsayılan olarak sadece anasayfa
    frequency: window.popupFrequency || 'session', // session, daily, weekly
    showOnce: window.popupShowOnce !== undefined ? window.popupShowOnce : true
  };

  // Çerez kontrol fonksiyonu
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Popup gösterme kontrolü
  function canShowPopup() {
    // Sayfa kontrolü
    const isCorrectPage = popupConfig.pages.includes(window.location.pathname);
    if (!isCorrectPage) return false;

    // Gösterim sıklığı kontrolü
    const popupCookie = getCookie('shopify_popup');
    if (popupConfig.showOnce && popupCookie) return false;

    return true;
  }

  // Popup oluşturma fonksiyonu
  function createPopup() {
    if (!canShowPopup() || !popupConfig.message) return;

    const popupHtml = `
      <div id="custom-flexible-popup" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div class="relative bg-white p-8 rounded-lg shadow-xl max-w-md w-full">
          <button id="close-flexible-popup" class="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
            ✕
          </button>
          <p class="text-lg text-center text-gray-800">
            ${popupConfig.message}
          </p>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', popupHtml);
    
    const popup = document.getElementById('custom-flexible-popup');
    const closeButton = document.getElementById('close-flexible-popup');
    
    closeButton.addEventListener('click', function() {
      popup.remove();
      
      // Çerez ayarla
      if (popupConfig.showOnce) {
        setCookie('shopify_popup', 'seen', 1);
      }
    });
  }

  // Belirli bir süre sonra popup'ı göster
  setTimeout(createPopup, 1000);
});
